import * as React from "react";

import { ExternalEventPath } from "../Engine/Core/EventManagement/ExternalEvents/ExternalEvent";
import { ExternalHookFunction } from "../Engine/Core/EventManagement/ExternalEvents/ExternalHookFunction";

import { useExternalEventManager } from "./FormObjectProvider";

export function useExternalEvent(pathArr: ExternalEventPath, handler: ExternalHookFunction): void {
    const externalEventManager = useExternalEventManager();
    const handlerRef = React.useRef<ExternalHookFunction>();

    React.useEffect(() => {
        handlerRef.current = handler;
    }, [handler]);

    React.useEffect(() => {
        const eventListener: ExternalHookFunction = x => handlerRef.current?.(x);
        externalEventManager.onExternalEvent(pathArr, eventListener);
        return () => {
            externalEventManager.offExternalEvent(pathArr, eventListener);
        };
    }, [pathArr.join("-")]);
}
